import { BMCalendar } from "@traveloka/district-bloom";
import { useLocale } from "../../../../core";
import { appendTestId } from "../../../../utils";
import {
  CalendarPickerComponentProps,
  RangeCalendarProps,
  SingleCalendarProps,
} from "./CalendarPicker";

export default function CalendarPickerComponent(
  props: CalendarPickerComponentProps
) {
  const { minDate, maxDate, value, onChange, testID } = props;
  const { locale } = useLocale();

  if (Array.isArray(value)) {
    // Handle date range selection
    return (
      <BMCalendar
        minDate={minDate}
        maxDate={maxDate}
        variant="horizontal"
        numberOfRenderedMonth={1}
        date={value}
        locale={locale}
        onChange={onChange as RangeCalendarProps["onChange"]}
        testID={appendTestId(testID, "calendar")}
      />
    );
  }

  return (
    <BMCalendar
      minDate={minDate}
      maxDate={maxDate}
      variant="horizontal"
      numberOfRenderedMonth={1}
      date={value}
      locale={locale}
      onChange={onChange as SingleCalendarProps["onChange"]}
    />
  );
}
